document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`#cmdk-input`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});

const target = document.querySelector('.quick-add-modal');

if (target) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open'
      ) {
        if (target.hasAttribute('open')) {
          document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
        }
      }
    });
  });

  observer.observe(target, { attributes: true });
}
